export interface IPlayer {
  displayName: string;
  givenName: string;
  googleId: string;
  id: number;
  loggedIn: boolean;
  photo: string | null;

  isAdmin: () => boolean;
  isLogged: () => boolean;
}

export const admins: { [key: string]: boolean } = { "107589715108607499143": true, "117206912680127751339": true };

export const displayNameMaxLength = 30;
export const displayNameMinLength = 5;
export const displayNameRegExp = /^[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ0-9_\- ]*$/;
